

export async function encryptMessage(message, key) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);

    // Якщо ключ передано у форматі HEX, перетворюємо його
    let keyData = typeof key === "string" && /^[a-fA-F0-9]+$/.test(key)
      ? hexToUint8Array(key)
      : new TextEncoder().encode(key);

    // Перевіряємо довжину ключа

    if (keyData.byteLength !== 16 && keyData.byteLength !== 32) {
      throw new Error("Ключ должен быть длиной 128 или 256 бит");
    }

    // Генерування ключа AES
    const importedKey = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-GCM" },
      false,
      ["encrypt"]
    );

    // Створення випадкового IV
    const iv = crypto.getRandomValues(new Uint8Array(12));

    // Шифрування
    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      importedKey,
      data
    );

    return {
      encrypted: btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer))),
      iv: Array.from(iv), // Перетворюємо IV для передавання в JSON
    };
}

export async function decryptMessage(encryptedMessage, key, ivArray) {
  const decoder = new TextDecoder();

  try {
    // Convert key to Uint8Array if it is in HEX format
    let keyData;
    if (typeof key === "string" && /^[a-fA-F0-9]+$/.test(key)) {
      keyData = hexToUint8Array(key);
    } else {
      keyData = new TextEncoder().encode(key);
    }

    // Check key length (128-bit or 256-bit keys are required for AES)
    if (keyData.byteLength !== 16 && keyData.byteLength !== 32) {
      throw new Error("Key must be 128 or 256 bits long");
    }

    // Import the AES-GCM key
    const importedKey = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // Decode the encrypted message from Base64
    const encryptedData = Uint8Array.from(
      atob(encryptedMessage),
      (char) => char.charCodeAt(0)
    );

    // Ensure IV is a valid 12-byte array
    if (!Array.isArray(ivArray) || ivArray.length !== 12) {
      throw new Error("Initialization vector (IV) must be an array of 12 bytes");
    }
    const iv = new Uint8Array(ivArray);

    // Perform decryption
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      importedKey,
      encryptedData
    );

    // Decode the decrypted buffer into a string and return
    return decoder.decode(decryptedBuffer);
  } catch (error) {
    console.error("Decryption failed:", error.message);
    window.location.url = '/'
    throw new Error("Failed to decrypt message. Ensure the input parameters are correct.");
  }
}

// Helper function to convert HEX string to Uint8Array
function hexToUint8Array(hex) {
  const length = hex.length;
  const uint8Array = new Uint8Array(length / 2);
  for (let i = 0; i < length; i += 2) {
    uint8Array[i / 2] = parseInt(hex.substr(i, 2), 16);
  }
  return uint8Array;
}
